import { Box, Grid, Stack } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useParams } from 'react-router';
import { BreadcrumbMeta } from 'v2/components/Breadcrumb/Breadcrumb';
import Loader from 'v2/components/Loader/Loader';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useCloudControllerDetails from 'v2/hooks/useCloudControllers/useCloudControllerDetails';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import SomethingWentWrong from 'v2/pages/GeneralErrors/SomethingWentWrong';
import Header from '../../DeviceDetails/components/Header';
import CloudControllerInfo from './components/CloudControllerInfo';
import ReadersCard from './components/ReadersCard';

const CloudControllerDetails: React.FC = () => {
  const { translation } = useTranslation();
  const { cloudControllerId } = useParams();
  const { showSnackbar } = useSnackbarContext();
  const { cloudController, cloudControllerLoading, hasCloudControllerFetchError, retryFetchingCloudController } =
    useCloudControllerDetails({
      translation,
      handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' }),
      cloudControllerId: cloudControllerId || ''
    });

  if (cloudControllerLoading) {
    return (
      <Box justifyContent="center" alignContent="center" sx={{ width: '100%', height: '60vh' }}>
        <Loader />
      </Box>
    );
  }

  if (hasCloudControllerFetchError) {
    return <SomethingWentWrong onRetry={retryFetchingCloudController} />;
  }

  if (!cloudController) {
    return <NotFound />;
  }

  return (
    <Stack spacing={4}>
      <BreadcrumbMeta
        breadcrumb={{
          title: cloudController.serialNumber,
          crumbs: [
            {
              text: translation.devices,
              path: '/devices'
            },
            {
              text: translation.cloud_controllers,
              path: '/devices/cloud-controllers'
            }
          ]
        }}
      />
      <Header
        deviceName={cloudController.serialNumber}
        isDeleteDeviceButtonVisible={false}
        handleOpenDeleteDeviceModal={() => undefined}
      />
      <Grid container spacing={4}>
        <Grid container spacing={4} size={{ xs: 12, lg: 4 }}>
          <Grid size={12}>
            <CloudControllerInfo cloudController={cloudController} />
          </Grid>
          <Grid size={12}>
            <ReadersCard readers={cloudController.readers} />
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default CloudControllerDetails;
